import React, { FC, useEffect, useState } from 'react';
import useTranslations from '@hooks/useTranslation';
import LecturerTemplate from '@ui/Lecturer/Lecturer';
import { publicAssets } from '@utils/url.utils';
import { getImageBaseURL } from '../../constants';
import { Description, DescriptionMoreLink, Lecturers, Wrapper } from './TrainingDescription.elements';

export interface TrainingDescriptionProps {
    lecturers: {
        photoKey: string;
        name: string;
        slug: string;
    }[];
    description: string;
    courseKey: string;
    isFavorite?: boolean;
}

const LINE_HEIGHT = 28;
const SPACE = 56;

const TrainingDescriptionTemplate: FC<TrainingDescriptionProps> = ({
    lecturers,
    description,
    courseKey,
    isFavorite: isFavoriteDefault,
}) => {
    const { t } = useTranslations();

    const [isVisibleFullDescription, setIsVisibleFullDescription] = useState(true);
    const [hideLink, setHideLink] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if ((document.getElementById('description').offsetHeight - SPACE) / LINE_HEIGHT <= 5) {
            setHideLink(true);
            setIsLoaded(true);
        } else {
            setIsVisibleFullDescription(false);
            setIsLoaded(true);
        }
    }, []);

    return (
        <Wrapper>
            <Lecturers>
                {lecturers?.map((lecturer, key) => (
                    <LecturerTemplate
                        key={key}
                        isBold
                        image={
                            lecturer?.photoKey
                                ? `${getImageBaseURL()}/media/people/${lecturer?.photoKey}`
                                : `${publicAssets('/avatar.svg')}`
                        }
                        name={lecturer?.name}
                        slug={lecturer?.slug}
                    />
                ))}
            </Lecturers>
            <Description
                className={`${isVisibleFullDescription ? 'long' : 'short'}`}
                dangerouslySetInnerHTML={{ __html: description?.replace('<img ', '<img width="auto"') }}
                id="description"
            />
            {description && !hideLink && isLoaded && (
                <DescriptionMoreLink onClick={() => setIsVisibleFullDescription(!isVisibleFullDescription)}>
                    {isVisibleFullDescription ? t('course.description.short') : t('course.description.long')}
                </DescriptionMoreLink>
            )}
        </Wrapper>
    );
};

export default TrainingDescriptionTemplate;
